<template>
  <v-card class="v-modal-new-window analyzed-dialog">
    <!-- [S]  Popup title-->
    <v-card-title primary-title class="headline white--text">
      {{ pageTitle }}
    </v-card-title>
    <!-- [E]  Popup title-->

    <!-- [S]  Popup body-->
    <!-- [S]  Toolbar-->
    <v-card-text class="info-section child-table-top-header pt-7">
      <v-row>
        <v-col cols="12" class="pb-0 pt-0">
          <v-row class="ma-0">
            <v-col cols="12" sm="3" class="pb-0 pl-0 pt-4">
              <span class="float-left"
                ><span class="subheader-text">Matching View </span>
                <span class="subheader-message"
                  >{{ this.countCompare }} {{ this.params.MSG_ID }}</span
                ><span class="subheader-text"> Messages</span></span
              >
            </v-col>
            <v-col cols="12" sm="9" class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12" sm="3" class="pa-0">
                  <!-- <span class="float-left"><span class="subheader-text">Total analyzed EDI File : </span><span class="total-text">{{this.params.MSG_CNT}}</span></span> -->
                </v-col>
                <v-col cols="12" sm="7" class="text-right pb-0 pr-0 pt-5">
                  <div class="pa-0">
                    <span class="filter-text">Not Used</span>
                    <toggle-button
                      v-model="filterQuery.not_used"
                      :labels="true"
                      :sync="true"
                      @change="toggleFilter"
                      :height="15"
                      :color="{
                        checked: this.checkedColor,
                        unchecked: this.unCheckedColor,
                        disabled: '#CCCCCC',
                      }"
                      :switch-color="{ checked: this.toggleButton, unchecked: this.toggleButton }"
                    />
                    <span class="filter-text">Qualifier</span>
                    <toggle-button
                      v-model="filterQuery.qualifier"
                      :labels="true"
                      :sync="true"
                      @change="toggleFilter"
                      :height="15"
                      :color="{
                        checked: this.checkedColor,
                        unchecked: this.unCheckedColor,
                        disabled: '#CCCCCC',
                      }"
                      :switch-color="{ checked: this.toggleButton, unchecked: this.toggleButton }"
                    />
                  </div>
                </v-col>
                <v-col cols="12" sm="2" class="pb-0 pr-0 ">
                  <v-text-field
                    v-model="query"
                    @input="onFilterMergeCompare"
                    class="search-matched-map-list-button custom-form-component search-button"
                    placeholder="Search"
                    append-icon="fas fa-search"
                    outlined
                    height="30"
                    dense
                    solo
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- [E]  Toolbar-->

    <!-- [S]  Table-->
    <v-card-text class="data-section">
      <v-row class="ma-0 pr-0">
        <v-col cols="12" sm="3" class="matching-wrap-content-left">
          <v-row class="tree-panel no-gutters">
            <v-col cols="12" class="text-left pt-0 pl-0 pr-0">
              <v-btn
                x-small
                tile
                @click="expandAllTreeView"
                class="expand-all-tree-view-button btn-height-custom"
                dark
                >{{ !expandAll ? 'Expand All' : 'Collapse All' }}</v-btn
              >
            </v-col>
            <v-col cols="12" class="col-tree">
              <v-treeview
                ref="analyzedTreeView"
                v-model="tree"
                :open="open"
                :items="treeItems"
                class="analyzedTree"
                activatable
                open-on-click
              >
                <template v-slot:label="{ item, open }">
                  <div
                    v-if="!item.disabled && typeof item.children != 'undefined'"
                    class="group-has-children-item"
                  >
                    <v-icon small class="mr-1">fa fa-object-group</v-icon>
                    <span class="group-name">{{ item.seg }}</span> - {{ item.req }} -
                    {{ item.loop }}
                  </div>
                  <div
                    v-if="item.disabled && typeof item.children != 'undefined'"
                    class="group-no-children-item"
                  >
                    <v-icon small color="#b9bbb7" class="mr-1">fa fa-object-group</v-icon>
                    <span class="group-name">{{ item.seg }}</span> - {{ item.req }} -
                    {{ item.loop }}
                  </div>
                  <div
                    v-if="typeof item.children == 'undefined' && !item.disabled"
                    class="child-visible-item"
                    @click="itemClick(item)"
                  >
                    <v-icon small class="mr-1">fa fa-cube</v-icon>
                    <span class="child-item">{{ item.seg }}</span> - {{ item.req }} -
                    {{ item.loop }} - {{ item.dataname }}
                  </div>
                  <div
                    v-if="typeof item.children == 'undefined' && item.disabled"
                    class="child-invisible-item"
                  >
                    <v-icon small color="#dbd7db" class="mr-1">fa fa-cube</v-icon>
                    <span class="child-item">{{ item.seg }}</span> - {{ item.req }} -
                    {{ item.loop }} - {{ item.dataname }}
                  </div>
                </template>
              </v-treeview>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="9" class="pt-0 pb-0 pr-0 pl-6">
          <v-row class="ma-0 matching-wrap-content-right">
            <v-table
              ref="layout_matching_table"
              :width="1300"
              :height="565"
              :title-rows="titleRows"
              :title-row-height="25"
              :columns="columns"
              :table-data="segTableItems"
              :column-cell-class-name="columnCellClass"
              :row-class-name="rowClassName"
              :errorContent="'No matching records found'"
              :is-loading="showLoading"
              :row-mouse-enter="rowHover"
              :row-mouse-leave="rowHoverOut"
              :row-click="rowClick"
              :lazy-loading="lazy_loading"
              class="v-popup-table compare-merge-table"
              is-horizontal-resize
            ></v-table>
          </v-row>
        </v-col>
      </v-row>

      <!-- [S]  Buttons-->
      <v-row class="btn-row">
        <v-col class="pa-0  text-right" cols="12">
          <v-btn class="ma-0 mr-3 btn-popup" tile color="#217346" dark>
            <v-icon small color="white" class="mr-1">far fa-file-excel</v-icon>
            Excel
          </v-btn>
          <v-btn class="ma-0 mr-0 btn-popup" tile color="#cd5f5f" dark @click="closePopup">
            <v-icon small color="white" class="mr-1">fa fa-times</v-icon>
            Close
          </v-btn>
        </v-col>
      </v-row>
      <!-- [E]  Buttons-->
    </v-card-text>
    <!-- [E]  Table-->
    <!-- [E]  Popup body-->
  </v-card>
</template>
<script>
/* globals Store */
import { mapState } from 'vuex';
import { MsgTreeParser } from '@/vue-dlb/utils/msgtree_parser';
import $ from 'jquery';

/*  Remove unuse code
import {
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress
} from "@/vue-dlb/utils/sys-util.js";
*/
const msgtreeParser = new MsgTreeParser();

export default {
  components: {},
  name: 'layout-matching-dialog',
  // props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd'],
  computed: {
    ...mapState('layout', {
      segItems: 'segItems',
      segTableItems: 'mergeViewItems',
    }),
    // compare_merge_table_header() {
    //   return [
    //     {text : "", value: "checkbox", "colspan" : 1, "rowspan" : 2},
    //     {text : "Seg.", value : "EFSEGMENT_ID", "colspan" : 1, "rowspan" : 2},
    //     {text : "Element", value : "ESDATAELEM", "colspan" : 1, "rowspan" : 2},
    //     {text : "Element Name", value : "ESDATANAME", "colspan" : 1, "rowspan" : 2},
    //     {text : "Req.", value : "ESREQUIRE", "colspan" : 1, "rowspan" : 2},
    //     {text : "Type", value : "EFDHTYPE", "colspan" : 1, "rowspan" : 2},
    //     {text : "Size", value : "EFDHMAXIMUM", "colspan" : 1, "rowspan" : 2},
    //     {text : "Value Info", value : "EFCODEDEFIN", "colspan" : 1, "rowspan" : 2},
    //     {text : "checkboxcompare1", value : "checkboxcompare", "colspan" : 2, "rowspan" : 1},
    //     {text : "checkboxcompare2", value : "checkboxcompare", "colspan" : 2, "rowspan" : 1},
    //     {text : "checkboxcompare3", value : "checkboxcompare", "colspan" : 2, "rowspan" : 1},
    //     {text : "checkboxcompare4", value : "checkboxcompare", "colspan" : 2, "rowspan" : 1},
    //     {text : "Element Biz. ID", value : "ELEM_ID", "colspan" : 1, "rowspan" : 2},
    //     {text : "MIG Name", value : "SEG_ELEM", "colspan" : 1, "rowspan" : 2},
    //   ]
    // }
  },
  data() {
    return {
      /* Remove unuse code
      numberFormatter: new Intl.NumberFormat('en-US'),
      files: {
        html: 'mdi-language-html5',
        js: 'mdi-nodejs',
        json: 'mdi-json',
        md: 'mdi-markdown',
        pdf: 'mdi-file-pdf',
        png: 'mdi-file-image',
        txt: 'mdi-file-document-outline',
        xls: 'mdi-file-excel',
      },
      analyzed_table_data : [],
      */
      filterQuery: {
        not_used: false,
        qualifier: false,
      },
      showLoading: false,
      lazy_loading: true,
      checkedColor: '#75C7AF',
      unCheckedColor: '#BFCBD9',
      toggleButton: '#FFFFFF',
      expandAll: false,
      dialog: false,
      query: '',
      pageTitle: 'Layout Matching View',
      tree: [],
      open: ['public'],
      treeItems: [],
      select_layout_rows: [],
      searchTreeItems: {
        header: [
          'CUST_ID',
          'STR_SNDR',
          'STR_RCVR',
          'MSG_ID',
          'MSG_VER',
          'DAT_TYPE',
          'FR_DAT',
          'TO_DAT',
          'PRCS_STS',
          'LAY_PRCS_NO',
          'ALIAS',
        ],
        data: [
          {
            CUST_ID: '',
            STR_SNDR: '',
            STR_RCVR: '',
            MSG_ID: '',
            MSG_VER: '',
            DAT_TYPE: '',
            FR_DAT: '',
            TO_DAT: '',
            PRCS_STS: '', // in case of DataAnalysis Tree selects all status data
            LAY_PRCS_NO: '',
            ALIAS: '',
          },
        ],
      },
      columns: [
        {
          field: 'custome',
          width: 60,
          titleAlign: 'center',
          columnAlign: 'center',
          type: 'selection',
          isFrozen: true,
        },
        { field: 'EFSEGMENT_ID', width: 60, columnAlign: 'center', isFrozen: true },
        { field: 'ESDATAELEM', width: 80, columnAlign: 'center', isFrozen: true },
        { field: 'ESDATANAME', width: 200, columnAlign: 'left', isFrozen: true },
        { field: 'ESREQUIRE', width: 60, columnAlign: 'center', isFrozen: true },
        { field: 'EFDHTYPE', width: 60, columnAlign: 'center', isFrozen: true },
        { field: 'EFDHMAXIMUM', width: 100, columnAlign: 'center', isFrozen: true },
        { field: 'EFCODEDEFIN', width: 160, columnAlign: 'center', isFrozen: true, isResize: true },
        { field: 'ELEM_ID', width: 130, columnAlign: 'center' },
        { field: 'SEG_ELEM', width: 130, columnAlign: 'center' },
      ],
      titleRows: [
        [
          { fields: ['custome'], title: '', titleAlign: 'center', rowspan: 2 },
          {
            fields: ['EFSEGMENT_ID'],
            title: 'Seg.',
            titleAlign: 'center',
            rowspan: 2,
            newprop: 'newprop',
          },
          { fields: ['ESDATAELEM'], title: 'Element', titleAlign: 'center', rowspan: 2 },
          { fields: ['ESDATANAME'], title: 'Element Name', titleAlign: 'center', rowspan: 2 },
          { fields: ['ESREQUIRE'], title: 'Req', titleAlign: 'center', rowspan: 2 },
          { fields: ['EFDHTYPE'], title: 'Type', titleAlign: 'center', rowspan: 2 },
          { fields: ['EFDHMAXIMUM'], title: 'Size', titleAlign: 'center', rowspan: 2 },
          { fields: ['EFCODEDEFIN'], title: 'Value Info', titleAlign: 'center', rowspan: 2 },
          { fields: ['ELEM_ID'], title: 'Element Biz. ID', titleAlign: 'center', rowspan: 2 },
          { fields: ['SEG_ELEM'], title: 'MIG Name', titleAlign: 'center', rowspan: 2 },
        ],
        [],
      ],
    };
  },

  methods: {
    getMergeViewData() {
      this.searchTreeItems.data = this.params;
      Store.dispatch('layout/getMergedDataBoth', this.searchTreeItems).then(() => {
        this.toggleFilter();
        this.buildTreeItems();
      });
    },
    buildTreeItems() {
      this.treeItems = msgtreeParser.parse(this.segItems)[0].children;
    },

    async itemClick(item) {
      await this.$nextTick(() => {
        this.showLoading = true;
        this.$refs.layout_matching_table.$forceUpdate();
      });
      await this.delay(100);
      await this.$nextTick();
      this.lazy_loading = false;
      await this.$nextTick();
      this.showLoading = false;
      setTimeout(() => {
        for (let i = 0; i < this.segTableItems.length; i++) {
          if (this.segTableItems[i].EFSEGMENT_ID === item.seg) {
            $('.compare-merge-table .v-table-rightview-special-border').scrollTop(i * 40);
            return;
          }
        }
        alert('Item not exist in table');
      }, 300);
    },

    delay: (ms) =>
      new Promise((res) => {
        setTimeout(res, ms);
      }),

    async loadIt() {
      this.isLoading = true;

      // wait for vdom -> dom
      await this.$nextTick();

      // force browser to rerender dom
      // by requesting some property
      // from newly created node
      let width = this.$refs.hey.width;

      // wait for some time, of course
      // higher than monitor refresh rate
      await this.delay(40);

      this.isDone = true;
      this.isLoading = false;
    },
    columnCellClass(rowIndex, columnName, rowData) {
      if (columnName == 'EFSEGMENT_ID') {
        return 'seg-col';
      }
      return `${columnName}-col`;
    },
    rowClassName(index, item) {
      let { val, cnt } = this.columnCompare[0];
      for (let i = 1; i < this.columnCompare.length; i++) {
        let col = this.columnCompare[i];
        if (item[val] != item[col.val]) {
          return 'different-layout-row';
        }
      }
      return '';
    },
    // removeDialog (dialog) {
    //     dialog.id = this.id;
    //     this.closeDialog(dialog);
    // },
    // selectDialog (obj) {
    //     this.dragStart(obj);
    // },
    // dialogDragEnd (obj) {
    //     this.dragEnd(obj);
    // },
    // selectOk() {
    //         this.$emit("select-ok", this.dataValue);
    //         this.dialog = false;
    // },
    // selectClose() {
    //   this.$emit("select-close", this.dataValue);
    //   this.dialog = false;
    // },
    // formatNumber(num) {
    //   return this.numberFormatter.format(num);
    // },
    // generateHTML(item) {
    //   let {name} = item;
    //   let arrStr = name.split(" - ");
    //   let data = {};
    //   // name req value text
    //   if (name.startsWith('Group')) {
    //     data['name'] = arrStr[0].split(" ")[2];
    //     data['req'] = arrStr[1];
    //     data['value'] = arrStr[2];
    //   } else {
    //     data['name'] = arrStr[0];
    //     data['req'] = arrStr[1];
    //     let sepIndex = arrStr[2].search(" ");
    //     data['value'] = arrStr[2].substr(0, sepIndex);
    //     data['text'] = arrStr[2].substr(sepIndex);
    //   }
    //   item['data'] = data;
    // },
    expandAllTreeView() {
      this.expandAll = !this.expandAll;
      if (this.expandAll) {
        this.$refs.analyzedTreeView.updateAll(this.expandAll);
      } else {
        this.$set(this, 'treeItems', []);
        this.$nextTick(() => {
          this.$set(this, 'treeItems', msgtreeParser.parse(this.segItems)[0].children);
        });
      }
    },
    onFilterMergeCompare(str) {
      this.showLoading = true;
      setTimeout(() => {
        Store.dispatch('layout/setFilterMergeCompare', {
          query: str,
          filterQuery: this.filterQuery,
        }).then(() => {
          this.showLoading = false;
        });
      }, 300);
    },
    toggleFilter(str) {
      this.showLoading = true;
      setTimeout(() => {
        Store.dispatch('layout/setFilter', { query: this.filterQuery, str: this.query }).then(
          () => {
            this.showLoading = false;
          },
        );
      }, 300);
    },
    rowHover(rowitem) {
      $('.v-table-btable').each(function() {
        if (window.theme) {
          $(this)
            .find('tr')
            .eq(rowitem)
            .addClass('theme--dark-merge-row-hover');
        } else {
          $(this)
            .find('tr')
            .eq(rowitem)
            .addClass('theme--light-merge-row-hover');
        }
      });
    },
    rowHoverOut(rowitem) {
      $('.v-table-btable').each(function() {
        if (window.theme) {
          $(this)
            .find('tr')
            .eq(rowitem)
            .removeClass('theme--dark-merge-row-hover');
        } else {
          $(this)
            .find('tr')
            .eq(rowitem)
            .removeClass('theme--light-merge-row-hover');
        }
      });
    },
    rowClick(rowitem) {
      $('.v-table-btable').each(function() {
        if (window.theme) {
          if (
            $(this)
              .find('tr')
              .hasClass('theme--dark-merge-row-click')
          ) {
            $(this)
              .find('tr')
              .removeClass('theme--dark-merge-row-click');
            $(this)
              .find('tr')
              .eq(rowitem)
              .addClass('theme--dark-merge-row-click');
          } else {
            $(this)
              .find('tr')
              .eq(rowitem)
              .addClass('theme--dark-merge-row-click');
          }
        } else {
          if (
            $(this)
              .find('tr')
              .hasClass('theme--light-merge-row-click')
          ) {
            $(this)
              .find('tr')
              .removeClass('theme--light-merge-row-click');
            $(this)
              .find('tr')
              .eq(rowitem)
              .addClass('theme--light-merge-row-click');
          } else {
            $(this)
              .find('tr')
              .eq(rowitem)
              .addClass('theme--light-merge-row-click');
          }
        }
      });
    },
  },
  created() {
    console.log('--------- created ----------');
    //[2020-04-01] apply by CLV build dynamic table

    if (window.theme) {
      this.$vuetify.theme.dark = true;
      this.checkedColor = '#38BA5C';
      this.unCheckedColor = '#292C35';
      this.toggleButton = '#292C35';
    } else {
      this.$vuetify.theme.dark = false;
      this.checkedColor = '#75C791';
      this.unCheckedColor = '#D0D4DD';
      this.toggleButton = '#FFFFFF';
    }
    this.countCompare = window.params.length;

    let index = 8;
    let index_first_row = 8;
    let index_second_row = 0;
    let arrFirstRow = [];

    this.columnCompare = [];
    for (let i = 0; i < window.params.length; i++) {
      let sender = window.params[i].STR_SNDR;
      let receiver = window.params[i].STR_RCVR;
      let alias = window.params[i].ALIAS;

      this.columns.splice(index++, 0, { field: `${alias}_VAL`, width: 100, columnAlign: 'center' });
      this.columns.splice(index++, 0, { field: `${alias}_CNT`, width: 60, columnAlign: 'center' });

      this.columnCompare.push({
        val: `${alias}_VAL`,
        cnt: `${alias}_CNT`,
      });
      arrFirstRow.push(`${alias}_VAL`);
      arrFirstRow.push(`${alias}_CNT`);

      let secondTitleRow = this.titleRows[1];
      secondTitleRow.splice(index_second_row++, 0, {
        fields: [`${alias}_VAL`],
        title: `${sender}_${receiver}`,
        titleAlign: 'center',
        titleCellClassName: 'compare-header',
      });
      secondTitleRow.splice(index_second_row++, 0, {
        fields: [`${alias}_CNT`],
        title: 'Count',
        titleAlign: 'center',
        titleCellClassName: 'compare-header',
      });
    }

    let firstTitleRow = this.titleRows[0];
    firstTitleRow.splice(index_first_row++, 0, {
      fields: arrFirstRow,
      title: 'Compare Value',
      titleAlign: 'center',
      colspan: arrFirstRow.length,
      titleCellClassName: 'compare-header',
    });
    this.params = window.params;
    this.getMergeViewData();
  },

  mounted() {
    setTimeout(() => {
      document.getElementsByClassName('overlay-background')[0].style.display = 'none';
    }, 1000);
  },
};
</script>

<style>
/*  Remove unuse code
.compare-merge-tabl .v-table-body {
   min-height: 565px;
}
.title-cell-class-name-test1 {
    background-color: #2db7f5;
}
.title-cell-class-name-test2 {
    background-color: #f60;
}
*/
.compare-merge-table {
  width: 100% !important;
  min-height: 565px;
}
.compare-merge-table .compare-header .table-title {
  font-size: 10px !important;
  font-weight: bold;
}
.compare-merge-table .compare-checkbox.v-input--selection-controls i {
  color: #223596 !important;
}
.compare-merge-table .change_row {
  background: #fbbfc6 !important;
}
.matching-wrap-content-left {
  height: 600px;
  padding: 20px 15px 15px 15px !important;
  box-sizing: border-box;
  border-radius: 3px;
}
.matching-wrap-content-right {
  height: 600px;
  padding: 20px 15px 15px 15px !important;
  box-sizing: border-box;
  border-radius: 3px;
}

.theme--light .analyzed-dialog .matching-wrap-content-left {
  background: #fafcff;
  border: 1px solid #f0f7fb;
}
.theme--dark .analyzed-dialog .matching-wrap-content-left {
  border: none;
  background-color: #292c35;
}
.theme--dark .compare-merge-table .v-table-leftview {
  background-color: #292c35;
}
.theme--light .analyzed-dialog .matching-wrap-content-right {
  background: #fafcff;
  border: 1px solid #f0f7fb;
}
.theme--dark .analyzed-dialog .matching-wrap-content-right {
  border: none;
  background-color: #292c35;
}
.btn-popup {
  width: 100px !important;
  height: 30px !important;
}
.search-col .v-input {
  margin: 0px 0px 10px 0px !important;
}
.btn-row {
  margin: 0px !important;
  padding: 10px 0px 0px 0px !important;
}
.col-tree {
  padding: 0px !important;
  margin: 0px !important;
}
.analyzed-dialog .tree-panel {
  background: #fafcff;
  border: none;
}
</style>
